<template>
  <div class="matches-container">
    <Loader v-if="loading" :loading="loading" />

    <template v-else>
      <section class="section-wrapper white">
        <next-steps />
      </section>

      <section class="section-wrapper gray py-5">
        <results-list
          v-if="hasNonFeaturedLenders"
          :matches="deal.matches"
          :dealId="dealId" />

        <no-results
          v-else
          :matches="deal.matches" :dealId="deal.id"/>
      </section>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import NextSteps from './NextSteps'
import NoResults from './NoResults'
import ResultsList from './ResultsList'

export default {
  name: 'MatchResultPage',
  components: {
    NextSteps,
    NoResults,
    ResultsList,
  },

  props: {
    dealId: String,
  },

  data: () => ({
    loading: true,
    deal: {},
  }),

  computed: {
    ...mapGetters('feathers', ['apiDeals', 'apiProducts']),

    hasNonFeaturedLenders () {
      return (
        (this.deal.matches || []).length &&
        this.deal.matches.some(({ featured }) => !featured)
      )
    },
  },

  created () {
    this.getLendersData()
  },

  methods: {
    ...mapMutations('questionnaireStore', [
      'SET_QUIZ_UNCOMPLETED',
      'CLEAR_MATCH_DATA',
      'CLEAR_DEAL_ID',
    ]),

    async getLendersData () {
      if (this.dealId) {
        try {
          this.deal = await this.apiDeals.get(this.dealId, {
            query: {
              $include: { Matches: true },
            },
          })
        } catch (error) {
          this.addAlert({
            type: 'error',
            message: `There was an error retrieving your deal information: ${error.message}`,
          })
        }
      } else {
        this.addAlert({
          type: 'error',
          message: 'There was an error when loading your deal',
        })
      }

      this.CLEAR_DEAL_ID()
      this.CLEAR_MATCH_DATA()
      this.SET_QUIZ_UNCOMPLETED()

      if (this.deal.matches.length) {
        const titles = this.deal.matches
          .map(({ product }) => product.title)
          .join(' | ')
        document.title = `Matches | ${titles}`
        this.$gtag.pageview({ page_path: document.title })
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .matches-container > .container {
    padding-top: 45px;
    padding-bottom: 45px;
  }
}
</style>
